



































import { loadScript } from '@superbet-group/web.lib.utilities';
import {
    computed,
    defineComponent,
} from '@vue/composition-api';

import {
    useI18n,
    useVuexStore,
} from '@superbet-group/web.lib.vue-utilities';
import accountIndex from '@store/modules/ui/user/account/accountIndex';
import authStore from '@store/modules/data/authentication/authenticationIndex';
import inboxIndex from '@store/modules/ui/inbox/inboxIndex';
import { SdsSkeletonEffect } from '@superbet-group/web.lib.ui-components';
import AccountUserInfoAvatar from './AccountUserInfoAvatar.vue';
import { formattedToTwoDecimals } from '@src/app/utils/balance';
import { shellLocalConfig } from '@src/config/shell/localConfig';
import { getShellConfig } from '@src/config/shell/config';

export default defineComponent({
    emits: ['profileClick'],
    props: {
        active: {
            type: Boolean,
            default: false,
        },
    },
    setup() {
        const { translate } = useI18n();

        const authModule = useVuexStore<typeof authStore>('data/authentication');

        const userBalance = authModule.getter('userBalance');
        const user = authModule.getter('user');

        const formattedBalance = computed(() => {
            if (userBalance.value == null || userBalance.value === '-' || isNaN(Number(userBalance.value))) {
                return undefined;
            }
            return formattedToTwoDecimals(userBalance.value);
        });

        const accountModule = useVuexStore<typeof accountIndex>('ui/user/account');
        const isBalanceLoading = accountModule.getter('isBalanceLoading');

        const inboxStore = useVuexStore<typeof inboxIndex>('ui/inbox');
        const numberOfNewMessages = inboxStore.state('numberOfNewMessages');

        const currency = computed(() => translate('currencyAbbreviation'));

        const isNotificationBadgeVisible = computed(() => numberOfNewMessages.value > 0);

        async function loadAmplitudeSdk(apiKey: string, userUuid: string) {
            await loadScript(`https://cdn.eu.amplitude.com/script/${apiKey}.js`, 'amplitudeSdk');
            (window as any).amplitude.init(apiKey, userUuid, {
                fetchRemoteConfig: true,
                autocapture: true,
            });
        }

        const amplitudeApiKey = getShellConfig().remoteConfig.amplitudeApiKey;
        if (amplitudeApiKey && user.value) {
            loadAmplitudeSdk(amplitudeApiKey, user.value.userUuid!);
        }

        return {
            user,
            formattedBalance,
            currency,
            isBalanceLoading,
            isNotificationBadgeVisible,
            isUsernameDisplayed: shellLocalConfig.isUsernameDisplayed,
            isBalanceShown: shellLocalConfig.header?.isBalanceShown,
        };
    },
    components: {
        AccountUserInfoAvatar,
        SdsSkeletonEffect,
    },
});
